<template>
    <div>
        <div class="dropdown__header dropdown__header--dark dropdown__header--big">
            <div class="dropdown__header-text dropdown__header-text--big dropdown__header-text--light">
                prihlásenie
            </div>
            <button v-if="showCloseIcon" class="dropdown__header-btn dropdown__header-btn--light"
                @click="onCloseclick">
                <span class="icon icon-close"></span>
            </button>
        </div>

        <div class="dropdown__body">
            <app-spinner v-if="authRequestState === 'success'" />

            <form @submit.prevent="onSubmit">
                <Field
                    :trimModel="true"
                    :fieldModel="$v.user.email"
                    :className="'input-field--dark'"
                    :field="usernameField">
                </Field>
                <Field
                    :fieldModel="$v.user.password"
                    :className="'input-field--dark'"
                    :field="passwordField">
                </Field>

                <div
                    class="dropdown__item--btn dropdown__item--btn-no-side-padding">
                    <button type="submit"
                        :disabled="authRequestState === 'running'"
                        class="button normal--button button--l button--full-width button--uppercase button--small-text">
                        <span v-if="authRequestState !== 'running'">
                            {{$t('components.auth.login.sign_in')}}
                        </span>
                        <span v-if="authRequestState === 'running'">
                            {{$t('components.auth.login.signing')}}
                        </span>
                    </button>
                </div>
            </form>

            <div class="row">
                <div class="col">
                    <button
                        @click="loginFacebook"
                        :disabled="authRequestState === 'running'"
                        type="button"
                        class="button normal--button button--uppercase  button--full-width  button--small-text">
                        Facebook
                    </button>
                </div>
                <div class="col">
                    <button
                        @click="loginGoogle"
                        :disabled="authRequestState === 'running'"
                        type="button"
                        class="button default--button button--uppercase  button--full-width  button--small-text">
                        Google
                    </button>
                </div>
            </div>


            <br />

            <p v-if="authRequestState === 'failure'"
                class="text text--error">
                {{$t('components.auth.login.error')}}
            </p>

            <p v-else-if="submitStatus === 'ERROR'" class="text text--error">
                {{$t('components.auth.login.validation_error')}}
            </p>

            <div v-if="openForgotPassword"
                class="dropdown__link text-link text-link--light"
                @click.prevent.stop="openForgotPassword">
                {{$t('components.auth.login.forgotten_pass')}}
            </div>

            <a v-else :href="restorePassFullPath" class="dropdown__link text-link text-link--light" @click.prevent="routeToRestorePassword">
                {{$t('components.auth.login.forgotten_pass')}}
            </a>

            <router-link :to="localeRoute('register')" class="dropdown__link text-link text-link--light">
                {{$t('components.auth.login.register')}}
            </router-link>
        </div>

        <div class="box box--space-inside box--light">
            <div class="box--flex box--flex-center">
                <div class="box--flex box--space-right-s">Bezplatnou registráciou získate množstvo výhod!</div>
                <button class="button normal--button button--l button--uppercase button--small-text">registrácia</button>
            </div>
        </div>


        <!--
        <a v-else :href="routeToRegister" class="link">
            Register
        </a>
        <span>email: test@test.cz pass: test</span>
        <br />
        -->


    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import Field from '../ui/Field';
import {
    attemptLogin,
    onLoginError,
    removeOnLoginError,
    loginFacebook,
    loginGoogle
} from '../../services/MapsfyApi';

export default {
    components: {
        Field
    },
    props: {
        routeToRestorePassword: {
            type: Function
        },
        onLogedIn: {
            type: Function
        },
        formId: {
            type: String,
            default: "login-form"
        },
        openForgotPassword: {
            type: Function
        },
        onCloseclick: {
            type: Function,
            required: false
        },
        showCloseIcon: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            authRequestState: null,
            submitStatus: null,
            user: {
                email: "",
                password: ""
            },
            emailId: this.formId + '-inputEmail',
            passwordId: this.formId + '-inputPassword',
            usernameField: {
                atrName: "username",
                dataType: "text",
                descr: this.$t('components.auth.login.email_field_desc'),
                isMandatory: true,
                maxValue: "85",
                minValue: "5",
                title: this.$t('components.auth.login.email_field_title')

            },
            passwordField: {
                atrName: "password",
                atrValue: null,
                dataType: "password",
                descr: this.$t('components.auth.login.pass_field_desc'),
                isMandatory: true,
                maxValue: 50,
                minValue: 2,
                regExpression: null,
                title: this.$t('components.auth.login.pass_field_title')
            }
        };
    },
    validations: {
        user: {
            email: {
                required
            },
            password: {
                required
            }
        }
    },
    created() {
        onLoginError(this.onLoginError);
    },
    beforeDestroy() {
        removeOnLoginError(this.onLoginError);
    },
    methods: {
        loginFacebook() {
            loginFacebook();
        },
        loginGoogle() {
            loginGoogle();
        },
        onLoginError(type) {
            console.log('type', type);
            this.authRequestState = 'failure';
        },
        onSubmit() {
            this.$v.$touch();

            this.submitStatus = null;
            if (this.$v.$invalid) {
                this.submitStatus = 'ERROR';
            }

            if (!this.$v.$invalid) {
                this.authRequestState = 'running';
                attemptLogin(this.user.email, this.user.password);
            }

        }
    },
    computed: {
        restorePassFullPath() {
            return this.$router.resolve(this.localeRoute({name: 'restore-password'})).href;
        },
        routeToRegister() {
            return this.$router.resolve(this.localeRoute({name: 'register'})).href;
        }
    }
};
</script>

<style scoped>
.link {
    color: #007bff;
}
</style>

